import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';

import { LessonTaskStepKeys } from '../../../../main/constants/lesson-task-step-keys.ts';
import { RootState } from '../../../../main/store/main.store.ts';
import { LessonTaskStepKey } from '../../../../main/types/asset/lesson.types.ts';

import { selectIsUsingTempTracking } from '../../../selectors/is-using-temp-tracking.selector.ts';

import { PROGRESS_SLICE_NAME, ProgressSliceState } from '../progress.slice.types.ts';

import { syncLastCompletedStepThunk } from './sync-last-completed-step.thunk.ts';

interface ReturnType {
  stepKey: LessonTaskStepKey;
  isUsingTempTracking: boolean;
}

export const completeStepThunk = createAsyncThunk<ReturnType, void>(
  `${PROGRESS_SLICE_NAME}/completeStepThunk`,
  (_, thunkApi): ReturnType => {
    const state = thunkApi.getState() as RootState;
    const isUsingTempTracking = selectIsUsingTempTracking(state);
    const currentStepKey = state.lesson.currentLessonTaskStepKey ?? LessonTaskStepKeys.DEFAULT_CURRENT;

    if (isUsingTempTracking) {
      return { stepKey: currentStepKey, isUsingTempTracking };
    }

    thunkApi.dispatch(syncLastCompletedStepThunk(currentStepKey));

    return { stepKey: currentStepKey, isUsingTempTracking };
  }
);

export const completeStepThunkExtraReducers = (
  builder: ActionReducerMapBuilder<ProgressSliceState>
): ActionReducerMapBuilder<ProgressSliceState> =>
  builder.addCase(completeStepThunk.fulfilled, (state, action) => {
    if (action.payload.isUsingTempTracking) {
      state.lastCompletedStepTemp = action.payload.stepKey;
    } else {
      state.lastCompletedStep = action.payload.stepKey;
    }
  });
